import gql from 'graphql-tag';

export default gql`
  mutation updateVisitorPassStatus($visitorPassId: UUID!, $status: String!) {
    updateVisitorPassStatus(visitorPassId: $visitorPassId, status: $status) {
      id
    }
  }
`;
